import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import { Button, Grid, Image } from 'semantic-ui-react';

import './styles.scss';
import box from '../assets/empty-folder.svg';
import redClose from '../assets/red-close.svg';
import { isEmpty } from '../utils/lodash';
import greenCorrect from '../assets/green-round-correct.svg';
import exclamation from '../assets/exclamation.svg';
import { useNavigate } from 'react-router-dom';

class EmptyContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { msg, classes, action, childrenComponent, t } = this.props;
    return (
      <Grid.Column mobile={16} tablet={16} computer={16} textAlign="center">
        <div className={classes ? classes : 'no-goals-container'}>
          <Image alt="box" src={box} />
          <label className="msg">{msg ? msg : ''}</label>
          {action && (
            <p className="msg-action" onClick={() => action.method()}>
              {action ? action.lbl : ''}
            </p>
          )}
          {childrenComponent && childrenComponent}
        </div>
      </Grid.Column>
    );
  }
}

class UnAuthorizedAccess extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { t } = this.props;
    return (
      <Grid.Column mobile={16} tablet={16} computer={16} textAlign="center">
        <div className="no-access">
          <Image src={box} size="tiny" />
          <label className="msg">{t('common.no_access')}</label>
        </div>
      </Grid.Column>
    );
  }
}

let SuccessContainer = ({
  surveyData,
  msg,
  header,
  success,
  button,
  buttonRoute,
  linkExpired,
  description = '/',
  overRideBtn = false,
  lang = null,
  t,
}) => {
  const navigate = useNavigate();
  const displaySurveyData = surveyData || {};
  const altLanguages = displaySurveyData.altLanguages || {};

  return (
    <Grid.Column mobile={16} tablet={16} computer={16} textAlign="center">
      <div className="no-goals-container">
        {linkExpired ? (
          <img
            className="public-error-icon"
            alt="exclamation"
            src={exclamation}
          />
        ) : success ? (
          <img
            className="public-error-icon"
            alt="greenCorrect"
            src={greenCorrect}
          />
        ) : (
          <img className="public-error-icon" alt="redClose" src={redClose} />
        )}

        {msg ? (
          <div className={'details-conatiner'}>
            {header
              ? [<label className="msg-header">{header}</label>, <br />]
              : null}
            <label className="msg">{msg}</label>
            {description ? <label className="desc">{description}</label> : null}
          </div>
        ) : (
          <>
            <div
              className={`msg survey-message ${lang === 'en' ? '' : 'hidden'}`}
              lang="en"
              dangerouslySetInnerHTML={{
                __html: displaySurveyData.successMessage
                  ? displaySurveyData.successMessage
                  : t('survey.completion_message'),
              }}
            />
            {Object.entries(altLanguages).map(
              ([thisLang, translations], idx) =>
                translations?.successMessage ? (
                  <div
                    key={idx}
                    className={`msg survey-message ${
                      thisLang === lang ? '' : 'hidden'
                    }`}
                    lang={thisLang}
                    dangerouslySetInnerHTML={{
                      __html: translations.successMessage,
                    }}
                  />
                ) : null
            )}
          </>
        )}

        {/*** TODO: get rid of this hardcoded yuckfest ***/}
        {!isEmpty(displaySurveyData) &&
        displaySurveyData.organisationId &&
        displaySurveyData.organisationId.id === 1094 ? (
          <>
            <label className="msg">
              {t('survey.cultural_analysis_thanks', {
                name: displaySurveyData.name,
              })}
            </label>
            <label className="msg">{t('survey.photo_link_description')}</label>
            <label className="msg">
              <a
                href="https://www.dropbox.com/sh/dmsywppzlyj6aaf/AACJEk3INZFC3OTUjNnHqxL0a?dl=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('survey.ana2020_official_photography')}
              </a>
            </label>
          </>
        ) : null}

        {(success || overRideBtn) && button ? (
          <Button
            type="submit"
            className="btn btn-primary genericVerify-button"
            onClick={() => navigate(buttonRoute)}
          >
            {button}
          </Button>
        ) : null}
      </div>
    </Grid.Column>
  );
};

// Wrap components with withTranslation HOC
EmptyContainer = withTranslation()(EmptyContainer);
UnAuthorizedAccess = withTranslation()(UnAuthorizedAccess);
SuccessContainer = withTranslation()(SuccessContainer);

export { EmptyContainer, UnAuthorizedAccess, SuccessContainer };
